import React, {useEffect, useState, useRef} from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {Confirm} from 'react-admin';
import getTicket from '../helpers/getTicket';
import navigationDiv from './navigationHeader';
import {TableauDialogType, TableauEmbed} from '@stoddabr/react-tableau-embed-live';

import configData from "../config/config.json";

import { PrintScaling, PrintPageSize, PrintOrientation  } from "https://tabback.ccbh.com/javascripts/api/tableau.embedding.3.latest.js";


import "../content/ccbhDashboard.TableauViz.css";
import "../content/base_2.0.css";
import "../content/home_2.0.css";
import '../content/ccbh-tableau-portal_2.0.css';
import '../content/navigation-header_2.0.css';

import VizDiv from './Viz';
import TimeOutDialog from './timeoutDialog';
import ExportOutDialog from './exportDialog';
import CheckSession from '../helpers/checkSession';
import NavigationDiv from './navigationHeader';
import { LuScaling, LuCopy, LuCopyPlus, LuFile, LuFileStack } from 'react-icons/lu';
import { postUserStat } from '../helpers/statHelpers';

const {tableau} = window;
var timeId = 0;

function TableauViz2({vizUrl, dashboard, siteId, userName, view, isFavorite, loginResult, selectedPage, favoriteWorkbooks}){
    const location = useLocation();
    let navigate = useNavigate();
    const user = location.state?.loginResult.user;

    var currentPage = '';
    const [url, SetVizUrl] = useState('');
    const [ticket, SetTicket] = useState('');
    const [isFavoritek, setFavorite] = useState(isFavorite);
    const [newViz, setViz] = useState(null);
    const [selectedPageb, setSelectedPage] = useState(selectedPage);
    const vizRef = useRef(tableau);

    async function revertViz() {
        console.log('reset clicked');
        const viz = vizRef.current;
        const workbook = viz.workbook;
        const activeSheet = workbook.activeSheet;
        viz.revertAllAsync().then(
            addStat('Reset', activeSheet.name)
        );
    };

    function redoViz() {
        console.log('redo clicked');
        const viz = vizRef.current;
        const workbook = viz.workbook;
        const activeSheet = workbook.activeSheet;
        viz.redoAsync().then(
            addStat('Redo', activeSheet.name)
        );
    };

    async function undoViz() {
       console.log.apply('Undo Clicked');
       const viz = vizRef.current;
       const workbook = viz.workbook;
       const activeSheet = workbook.activeSheet;
       viz.undoAsync().then(
            addStat('Undo', activeSheet.name)
       );
    };

    const addStat = async(elementName, worksheetName) => {
        //acttion - undo, redo etc
        return await postUserStat(user.authorization, userName, 'Viz Display', elementName, dashboard.name, worksheetName);
    };
    
    const [showExportDialog, setShowExportDialog] = useState(false);
    const exportPDF = async(event, printOption) =>{
        event.preventDefault();
        let viz = document.getElementById('tableauViz');
        const workbook = viz.workbook;
        const activeSheet = workbook.activeSheet;
        const exportOptions = {
            scaling: PrintScaling.Automatic,
            pageSize: PrintPageSize.Letter,
            orientation: PrintOrientation.Landscape
        };

        console.log("Print Option:" + printOption);

        if(printOption == "all"){
            const publishedSheetNames = workbook.publishedSheetsInfo.map((publishedSheetInfo) => publishedSheetInfo.name);
            await viz.exportPDFAsync(publishedSheetNames, exportOptions).then(
                addStat('Export PDF', activeSheet.name)
            );
        }else{
            await viz.exportPDFAsync([activeSheet.name], exportOptions).then(
                addStat('Export PDF', activeSheet.name)
            );
        }
    };

    const openPrintPP = async(event) => {
        event.preventDefault();
        
        let viz = document.getElementById('tableauViz');
        const workbook = viz.workbook;
        const activeSheet = workbook.activeSheet;

        const publishedSheetNames = workbook.publishedSheetsInfo.map((publishedSheetInfo) => publishedSheetInfo.name);
        await viz.exportPowerPointAsync(publishedSheetNames).then(
            addStat('Export PowerPoint', activeSheet.name)
        );

    };

    const [openConfirm, setOpen] = useState(false);
    const handleDialogClose = (event) => {
        exportPDF(event, "single");
        setOpen(false);
    };

    const handleConfirm = (event) =>{
        exportPDF(event, "all");
        setOpen(false);
    };
    
    const openConfirmDialog = async(event) => {
        const viz = vizRef.current;
        const workbook = viz.workbook;
        addStat('Export', workbook.activeSheet.name);
        
        setShowExportDialog(true);
    };

    
    
    function handleTabSwitch(){
        console.log("Switched Tab - viz");
        const viz = vizRef.current;
        const sheet = viz.workbook.activeSheet;
    };

    const controlDiv = () => {
        return(
            <>
                <div id="report-vw-port">
                    <div className="tab-toolbar" id="dashboard-control">
                        <div className="tab-toolbar-button-wrapper">           
                            <div className="tabToolbarButton" >
                                <button className='undo'  type='button' onClick={undoViz} title="Undo last action on a sheet" >Undo</button>
                            </div>

                            <div className="tabToolbarButton" >
                                <button className='undo'  type='button' onClick={redoViz} title="Redoes last action on a sheet" >Redo</button>
                            </div> 
                            
                            <div className="tabToolbarButton" >
                                <button className='undo' type='button' onClick={revertViz} title="Restores the workbook to its starting state" >Reset</button>
                            </div>

                            <div className="tabToolbarButton">
                                <button className='undo' type='button' onClick={openConfirmDialog} title="Export TO PDF or PowerPoint">Export</button>
                            </div>

                            {showExportDialog &&
                                <ExportOutDialog onClose={() => {
                                    addStat('Cancel', '');
                                    setShowExportDialog(false);
                                }}
                                isOpen={showExportDialog}
                                userName={userName}
                                />
                            }
                        </div>
                    </div>
                </div>
            </>
        );
    };
    const cDiv = controlDiv();

    const fetchTrustTicket = async() => {
        const ticket = await getTicket(userName, siteId);
        return ticket;
    }

    const handleIt = event => {
        console.log('click', event);
    }

    const firstInit = () => {
        let viz = document.getElementById('tableauViz');
        viz.addEventListener("tabswitched", handleTabSwitch);
    }

    useEffect(() => {
        (async() => {
            await fetchTrustTicket().then((ticket) => {
                console.log('Viz-b ticket:');
                console.log(ticket);
                
                SetTicket(ticket);
                SetVizUrl(
                    configData.TableauBackEndServer + 
                    "/trusted/" + ticket + 
                    "/t/" + siteId + 
                    "/views/" + view +
                    "?:embed=yes&:customViews=yes&:showShareOptions=false");
                
                });
        })();

        /*
        fetchTrustTicket().then((ticket) => {
          console.log('Viz-b ticket:');
          console.log(ticket);
          
          SetTicket(ticket);
          SetVizUrl(
            configData.TableauBackEndServer + 
            "/trusted/" + ticket + 
            "/t/" + siteId + 
            "/views/" + view +
            "?:embed=yes&:customViews=yes&:showShareOptions=false");
           
        });*/
    }, []);
    
    const tableauVizDiv = () => {
        return(
            <>
            <TableauEmbed sourceUrl={url}
                          class="print-area"
                          toolbar="hidden" 
                          {...{"hide-tabs":undefined}} 
                          ref={vizRef} 
                          height="940px"
                          width="1640px"
                          margin="0" 
                          onTabSwicthed={(e) => {
                            console.log('Switched Tabs', e);
                          }}
                          OnEventListenerTabSwitched={(e) =>{
                            console.log("Event Switched", e);
                          }}
                          OnEventListenerFirstVizSizeKnown={(e) =>{
                            console.log("First Inertactive Event",e);
                          }}
                          onFirstVizSizeKnown={(e) =>{
                            console.log("onFirstInteractive no event");
                          }}
                          onMarkSelectionChanged={(e) => {
                                console.log("callback example: onMarkSelectionChanged:", { e });
                            }
                          }
                          onEventListenerMarkSelectionChanged={(e) => {
                                console.log("callback example: onEventListenerMarkSelectionChanged:",{ e });
                            }
                          }
                          onUrlAction={(e) => {
                            console.log('on url action', e);
                          }}
                          OnEventListenerUrlAction={(e) => {
                            console.log('Event URL action', e);
                          }}
                          onFirstInteractive={(e) => {
                            console.log('1st interactive', e);
                          }}
                          onEventListenerFirstInteractive = {(e) => {
                            console.log('on event 1st', e);
                            firstInit();
                          }}


                          />
            </>
        );
    }
        
    const tDiv =  tableauVizDiv(); 
    if (url === "") {
        return null;
    } else {
        return (
            <>
                {tDiv}
                {cDiv}
            </>
        );

    }

    

}

export default TableauViz2;